module.exports = __webpack_public_path__ + "img/t4-feature-text.213db549.png";